import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const Home: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 13.8 13.1',
  d = 'M10.34 13.1H9a1.38 1.38 0 0 1-1.38-1.38V9.65H6.21v2.07a1.38 1.38 0 0 1-1.38 1.38H3.45a1.38 1.38 0 0 1-1.38-1.38V7.55H.69a.6.6 0 0 1-.62-.41.63.63 0 0 1 .14-.76L6.41.21a.67.67 0 0 1 1 0l6.21 6.21a.63.63 0 0 1 .14.76.6.6 0 0 1-.66.37h-1.38v4.14a1.38 1.38 0 0 1-1.38 1.41zM5.52 8.27h2.76a.65.65 0 0 1 .72.69v2.76h1.38V6.89a.65.65 0 0 1 .62-.68h.41L6.9 1.65 2.34 6.21h.41a.65.65 0 0 1 .69.69v4.83h1.39V8.96a.65.65 0 0 1 .69-.69z',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullHeightStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      cssHelper={cssHelper}
      aria-label='Home Icon'
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path fill={fill} d={d} transition={transition} />
    </Elements.Svg>
  );
};

export default Home;
